import { Article, Aside, Body } from '@rezdy/components/Layout/Article';
import Layout from '@rezdy/components/Layout/DarkCentered';
import React, { PropsWithChildren } from 'react';
import { BookingSoftwareMarketingCard } from '../BookingSoftwareMarketingCard';
import SecondaryAction from './SecondaryAction';

export const MarketingLayout = ({ children }: PropsWithChildren<{}>) => (
    <Layout secondaryAction={<SecondaryAction />}>
        <Article style={{ alignItems: 'start' }}>
            <Body>{children}</Body>
            <Aside>
                <BookingSoftwareMarketingCard />
            </Aside>
        </Article>
    </Layout>
);
